import { render, staticRenderFns } from "./StopCalendarSideBar.vue?vue&type=template&id=049d8b58&scoped=true&"
import script from "./StopCalendarSideBar.vue?vue&type=script&lang=js&"
export * from "./StopCalendarSideBar.vue?vue&type=script&lang=js&"
import style0 from "./StopCalendarSideBar.vue?vue&type=style&index=0&id=049d8b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049d8b58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049d8b58')) {
      api.createRecord('049d8b58', component.options)
    } else {
      api.reload('049d8b58', component.options)
    }
    module.hot.accept("./StopCalendarSideBar.vue?vue&type=template&id=049d8b58&scoped=true&", function () {
      api.rerender('049d8b58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Scheduler/StopCalendarSideBar.vue"
export default component.exports